export default __webpack_public_path__ + "static/media/candidate.work_learn_tab.nutrition.79a56ad4.jpg";